// extracted by mini-css-extract-plugin
module.exports = {"headLeft":"index_headLeft_1MuRY","headRight":"index_headRight_1sB4x","wrapContent":"index_wrapContent_4LQOZ"};